import { Box, Button, Container, Stack } from '@chakra-ui/react'
import { Prose } from '@nikolovlazar/chakra-ui-prose'
import Head from 'next/head'
import Image from 'next/legacy/image'

const Page = () => {
  return (
    <>
      <Head>
        <title>Deboss Garage - Open House 2023</title>
      </Head>
      <Box
        py={6}
        textAlign='center'
        style={{
          backgroundColor: '#9a9a9a',
          backgroundImage: 'url(/img/open-house-2023/blue-bg.png)',
          backgroundSize: 'cover',
        }}>
        <Button
          as='a'
          colorScheme='green'
          href='https://airtable.com/apph5GMpHBFcOT4sI/shrnAGYtc9tdx8u5A'
          target='_blank'
          rel='noreferrer'>
          Register For Open House
        </Button>
      </Box>
      <div className='relative'>
        <iframe
          style={{ aspectRatio: '16 / 9', width: '100%' }}
          src='https://www.youtube.com/embed/KtCdskva7CA?si=T97xIl3crAgxXPFQ'
          title='YouTube video player'
          frameBorder='0'
          allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
          allowFullScreen
        />

        <Container maxW={{ base: 'md', lg: '7xl' }} py='20'>
          <Stack
            direction={{ base: 'column', lg: 'row' }}
            gap={{ default: 12, lg: 20 }}>
            <div style={{ padding: '1rem' }}>
              <Image
                style={{ maxWidth: '100%' }}
                src='/img/open-house-2023/date.png'
                alt='Saturday October 14th, 2023'
                width={755}
                height={1274}
              />
            </div>
            <div style={{ padding: '1rem' }}>
              <Image
                style={{ maxWidth: '100%' }}
                src='/img/open-house-2023/heading.png'
                alt='Deboss Garage Open House Cruise &amp; Car Show 2023'
                width={1279}
                height={1959}
              />
            </div>
            <div style={{ padding: '1rem' }}>
              <Image
                style={{ maxWidth: '100%' }}
                src='/img/open-house-2023/cruise.png'
                alt='Cruise starts at Chippawa Willoughby Memorial Arena'
                width={768}
                height={1236}
              />
            </div>
          </Stack>
        </Container>
        <Container maxW='2xl'>
          <Prose>
            <p>
              Attention Car Enthusiasts,
              <br />
              The excitement is electrifying, and the anticipation is real!
              We’re thrilled to invite you to an unparalleled automobile
              experience at the Deboss Garage Open House Cruise & Car Show 2023,
              featuring an exclusive meet and greet with Edison Motors and their
              show-stopping “Topsy” – the awe-inspiring Hybrid Diesel-EV Semi
              Truck!
            </p>

            <h4>Event Details</h4>

            <ul>
              <li>Date: Saturday, October 14, 2023</li>
            </ul>
            <li>
              Cruise Starts @ 11am in Chippawa Willoughby Memorial Arena Parking
              Lot
            </li>
            <li>
              Open House Location (Cruise Ends Here): 1261 Victoria Ave,
              Fenwick, ON Canada
            </li>
            <li>Gates Open 12pm - 6pm</li>
            <li>
              $5 Suggested Donation - 100$% of donations go to Truth For Teens
            </li>
            <p>(Charity #831010871RR0001)</p>

            <h4>🚗 Rod & Classic Car Cruise 🚗</h4>

            <p>
              Rev those engines, car enthusiasts! Dive into a nostalgia-driven
              road trip through the twisty turns of the Niagara Region with our
              Rod & Classic Car Cruise, where the sheer artistry of vintage
              automotive engineering meets those jaw-dropping Canadian views.
              The Niagara Region isn’t just famed for its killer landscapes and
              history-rich landmarks – it’s the ultimate stage for these classic
              beasts to strut their stuff. Whether you’re here to flex your own
              ride or just soak in the metallic magnificence, let’s all bask in
              a blend of gearhead wonder and the raw beauty of nature together,
              shall we? Let’s make those engines roar and tires roll, folks!
            </p>

            <a
              href='https://maps.app.goo.gl/uSeCUGdZCkKaijho8'
              target='_blank'
              rel='noreferrer'>
              <Image
                src='/img/open-house-2023/map.png'
                width='1840 '
                height='918'
                alt='Cruise Map'
              />
            </a>

            <p>
              11:30 Departure - Directions begin at 9000 Sodom Rd, Niagara
              Falls, ON L2E 6S6
            </p>
            <Button
              as='a'
              colorScheme='green'
              style={{ color: 'white' }}
              href='https://maps.app.goo.gl/uSeCUGdZCkKaijho8'
              target='_blank'
              rel='noreferrer'>
              View Map
            </Button>

            <h4>🔌 Sparking Interest: Spotlight on “Topsy” 🔌</h4>

            <p>
              Don’t miss the chance to get up close and personal with “Topsy,”
              the groundbreaking Hybrid Diesel-EV Semi Truck hailing from
              British Columbia, brought to you by Edison Motors. Explore the
              technological prowess and innovative designs that propel the
              future of electric trucking!
            </p>

            <h4>🤝 Connect with Edison Motors 🤝</h4>

            <p>
              Join us for an insightful meet & greet session with Chase Barber,
              brilliant mind and CEO behind Edison Motors. Engage in compelling
              discussions, discover what’s charging up in the EV world, and
              perhaps glimpse into the electrifying future of transportation!
            </p>

            <Image
              src='/img/open-house-2023/topsy.png'
              width='590'
              height='464'
              alt='Edison Motors'
            />

            <h4>🚘 A Showcase of Magnificent Machines 🚘</h4>

            <p>
              We have over 100 vehicles registered to be on display, from
              vintage classics to contemporary marvels, all while mingling with
              fellow auto enthusiasts. Every model has a story, every make has a
              legacy, and every car is a celebration of engineering and design.
            </p>

            <h4>🎁 Prizes, Surprises & More 🎁</h4>

            <p>Car show categories:</p>

            <ul>
              <li>Filthiest Car (Rich’s Favourite)</li>
              <li>Seen Yer Car (Oldest Car)</li>
              <li>Coal Commander (Best Diesel)</li>
              <li>Save the Squirrels (Loudest Car)</li>
              <li>How Far Is That? (Highest Mileage)</li>
              <li>Set the Bar High (Tallest Vehicle)</li>
            </ul>

            <p>
              Winners and prizes presented by Princess Auto, and will be
              announced between 3 pm and 4 pm.
            </p>

            <Image
              src='/img/open-house-2023/sponsors.png'
              width='909'
              height='599'
              alt='Prizes'
            />

            <h4>🎟️ Register NOW! 🎟️</h4>

            <p>
              This is an un-ticketed event, and registration does not permit or
              prevent anyone from showing up. But pre-registrations help us have
              a good idea of what to expect on October 14! Plus we can send you
              any updates prior to the event so you don’t miss out on important
              details!
            </p>
          </Prose>
        </Container>
        <Container maxW='2xl' pb={20}>
          <a
            href='https://airtable.com/apph5GMpHBFcOT4sI/shrnAGYtc9tdx8u5A'
            target='_blank'
            rel='noreferrer'>
            <Image
              src='/img/open-house-2023/signup.png'
              alt='Register Now'
              width={1705}
              height={587}
            />
          </a>
        </Container>
      </div>
    </>
  )
}

export default Page
